export const subdivisionTranslations = {
  de: {
    label: 'Département',
    genericLabel: 'Geografische Unterteilung',
    filter: 'Département (Hauptadresse)',
    hint: 'Code oder Name suchen. Ein Adressvorschlag übernimmt Ort, Département und Region gemeinsam.',
    conflict:
      'Département, Ort/PLZ oder Region passen laut Referenzdaten nicht zusammen. Bitte prüfen; Ihre Auswahl bleibt erhalten.',
    incomplete: 'Bitte Code und Name gemeinsam angeben oder beide leeren.',
    countryRequired: 'Bitte das Land der geografischen Zuordnung angeben.',
    invalidPair:
      'Départementcode und Name passen nicht zum französischen Katalog. Bitte einen gültigen Eintrag auswählen.',
    countryChanged:
      'Das bisherige französische Département passt nicht zum neuen Land. Bitte leeren oder neu zuordnen.',
    cleared: 'Geografische Zuordnung nach Länderwechsel entfernt.',
    code: 'Départementcode',
    name: 'Départementname',
    region: 'Region',
  },
  en: {
    label: 'Département',
    genericLabel: 'Geographic subdivision',
    filter: 'Département (main address)',
    hint: 'Search by code or name. An address suggestion applies city, département and region together.',
    conflict:
      'The département, city/postcode or region do not match the reference data. Please review; your selection is retained.',
    incomplete: 'Enter both code and name, or clear both.',
    countryRequired: 'Specify the country for the geographic subdivision.',
    invalidPair:
      'The département code and name do not match the French catalogue. Please choose a valid entry.',
    countryChanged:
      'The previous French département does not match the new country. Clear it or select another subdivision.',
    cleared: 'Geographic subdivision cleared after changing country.',
    code: 'Département code',
    name: 'Département name',
    region: 'Region',
  },
  fr: {
    label: 'Département',
    genericLabel: 'Subdivision géographique',
    filter: 'Département (adresse principale)',
    hint: 'Recherchez par code ou nom. Une proposition reprend ensemble commune, département et région.',
    conflict:
      'Le département, la commune/le code postal ou la région ne correspondent pas aux données de référence. Vérifiez ; votre choix est conservé.',
    incomplete: 'Renseignez le code et le nom ensemble, ou effacez les deux.',
    countryRequired: 'Précisez le pays de la subdivision géographique.',
    invalidPair:
      'Le code et le nom du département ne correspondent pas au catalogue français. Choisissez une entrée valide.',
    countryChanged:
      'Le département français précédent ne correspond pas au nouveau pays. Effacez-le ou choisissez une autre subdivision.',
    cleared: 'Subdivision géographique effacée après le changement de pays.',
    code: 'Code du département',
    name: 'Nom du département',
    region: 'Région',
  },
  es: {
    label: 'Departamento francés',
    genericLabel: 'Subdivisión geográfica',
    filter: 'Departamento (dirección principal)',
    hint: 'Busque por código o nombre. Una sugerencia aplica localidad, departamento y región juntos.',
    conflict:
      'El departamento, localidad/código postal o región no coinciden con los datos de referencia. Revise los valores; se conserva su selección.',
    incomplete: 'Indique código y nombre juntos, o borre ambos.',
    countryRequired: 'Indique el país de la subdivisión geográfica.',
    invalidPair:
      'El código y nombre del departamento no coinciden con el catálogo francés. Elija una entrada válida.',
    countryChanged:
      'El departamento francés anterior no corresponde al nuevo país. Bórrelo o elija otra subdivisión.',
    cleared: 'Subdivisión geográfica borrada tras cambiar el país.',
    code: 'Código del departamento',
    name: 'Nombre del departamento',
    region: 'Región',
  },
  tr: {
    label: 'Fransız departmanı',
    genericLabel: 'Coğrafi alt bölüm',
    filter: 'Departman (ana adres)',
    hint: 'Kod veya adla arayın. Adres önerisi şehir, departman ve bölgeyi birlikte aktarır.',
    conflict:
      'Departman, şehir/posta kodu veya bölge referans verilerle uyuşmuyor. Kontrol edin; seçiminiz korunur.',
    incomplete: 'Kod ve adı birlikte girin veya ikisini de silin.',
    countryRequired: 'Coğrafi alt bölümün ülkesini belirtin.',
    invalidPair: 'Departman kodu ve adı Fransız kataloğuyla uyuşmuyor. Geçerli bir kayıt seçin.',
    countryChanged:
      'Önceki Fransız departmanı yeni ülkeyle uyuşmuyor. Silin veya başka bir alt bölüm seçin.',
    cleared: 'Ülke değişikliğinden sonra coğrafi alt bölüm silindi.',
    code: 'Departman kodu',
    name: 'Departman adı',
    region: 'Bölge',
  },
} as const;
